import type * as React from "react"

const INVOICE_STATUSES = {
  PENDING: 1,
  PAID: 2,
  OVERDUE: 3,
  DRAFT: 4,
  ISSUED: 5,
  PARTIALLY_PAID: 6,
  VOID: 7
} as const

const INVOICE_TYPES = {
  RECEIVABLE: 1,
  PAYABLE: 2
} as const

type InvoiceTypes = (typeof INVOICE_TYPES)[keyof typeof INVOICE_TYPES]

const isConcreteInvoiceType = (
  value: number | null | undefined
): value is InvoiceTypes =>
  value === INVOICE_TYPES.RECEIVABLE || value === INVOICE_TYPES.PAYABLE

type InvoiceStatusesKeys = keyof typeof INVOICE_STATUSES
type InvoiceStatuses = (typeof INVOICE_STATUSES)[InvoiceStatusesKeys]

const INVOICE_STATUSES_MAP: Record<
  InvoiceStatuses,
  {
    id: InvoiceStatuses
    value: InvoiceStatuses
    label: string
    style: React.CSSProperties
  }
> = {
  [INVOICE_STATUSES.PENDING]: {
    id: INVOICE_STATUSES.PENDING,
    value: INVOICE_STATUSES.PENDING,
    label: "Pending",
    style: {
      color: "#9E5E00",
      backgroundColor: "#FFF3E0",
      borderColor: "#FFF3E0"
    }
  },
  [INVOICE_STATUSES.PAID]: {
    id: INVOICE_STATUSES.PAID,
    value: INVOICE_STATUSES.PAID,
    label: "Paid",
    style: {
      color: "#367B38",
      backgroundColor: "#E8F5E9",
      borderColor: "#E8F5E9"
    }
  },
  [INVOICE_STATUSES.OVERDUE]: {
    id: INVOICE_STATUSES.OVERDUE,
    value: INVOICE_STATUSES.OVERDUE,
    label: "Overdue",
    style: {
      color: "#D4190C",
      backgroundColor: "#FFEBEE",
      borderColor: "#FFEBEE"
    }
  },
  [INVOICE_STATUSES.DRAFT]: {
    id: INVOICE_STATUSES.DRAFT,
    value: INVOICE_STATUSES.DRAFT,
    label: "Draft",
    style: {
      color: "#556E7A",
      backgroundColor: "#ECEFF1",
      borderColor: "#ECEFF1"
    }
  },
  [INVOICE_STATUSES.ISSUED]: {
    id: INVOICE_STATUSES.ISSUED,
    value: INVOICE_STATUSES.ISSUED,
    label: "Issued",
    style: {
      color: "#0A6EBD",
      backgroundColor: "#E3F2FD",
      borderColor: "#E3F2FD"
    }
  },
  [INVOICE_STATUSES.PARTIALLY_PAID]: {
    id: INVOICE_STATUSES.PARTIALLY_PAID,
    value: INVOICE_STATUSES.PARTIALLY_PAID,
    label: "Partially Paid",
    style: {
      color: "#00776C",
      backgroundColor: "#E0F2F1",
      borderColor: "#E0F2F1"
    }
  },
  [INVOICE_STATUSES.VOID]: {
    id: INVOICE_STATUSES.VOID,
    value: INVOICE_STATUSES.VOID,
    label: "Void",
    style: {
      color: "#6F6F6F",
      backgroundColor: "#F5F5F5",
      borderColor: "#F5F5F5"
    }
  }
}

export {
  INVOICE_STATUSES,
  INVOICE_STATUSES_MAP,
  INVOICE_TYPES,
  isConcreteInvoiceType,
  type InvoiceStatuses,
  type InvoiceTypes
}
